/**
 * 用户头像组件
 * 优先显示头像图片，无图片时显示文字头像
 */
import React from 'react';
import { Avatar, AvatarProps } from '@arco-design/web-react';

interface UserAvatarProps extends Omit<AvatarProps, 'children'> {
  name: string; // 用户姓名，用于生成文字头像
  avatarUrl?: string | null; // 用户头像 URL
}

/**
 * 获取头像显示文字（姓名最后一个字）
 * 这是项目中最常见的文字头像方式
 */
function getAvatarText(name: string): string {
  if (!name) return '?';
  return name.slice(-1); // 取最后一个字
}

/**
 * 用户头像组件
 * - 如果有 avatarUrl，显示图片头像
 * - 如果没有 avatarUrl，显示文字头像（使用姓名最后一个字）
 */
function UserAvatar({ name, avatarUrl, ...restProps }: UserAvatarProps) {
  // 如果有头像 URL，显示图片
  if (avatarUrl) {
    return (
      <Avatar {...restProps}>
        <img alt={name} src={avatarUrl} />
      </Avatar>
    );
  }

  // 如果没有头像 URL，显示文字头像
  return (
    <Avatar {...restProps} style={{ backgroundColor: '#165DFF', ...restProps.style }}>
      {getAvatarText(name)}
    </Avatar>
  );
}

export default UserAvatar;
